<h2 mat-dialog-title>Detalhes</h2>
<hr style="border: 0; border-top: solid 1px #0000003f; width: 100%; margin-top: 0;" />
<mat-dialog-content>
  <div [ngSwitch]="tipoLog">
    <div *ngSwitchCase="'ERRO'">
      <span>{{ detalhes.erroMsg }}</span>
    </div>
    <div *ngSwitchCase="'LOGIN'">
      <p><b>Usuário:</b> #{{ detalhes.idUsuario }} - {{ detalhes.identificacao }}</p>
      <p><b>Nome:</b> {{ detalhes.nomeUsuario }}</p>
      <p><b>CPF:</b> {{ detalhes.cpf }}</p>
      <p>
        <b>Unidade:</b> {{ detalhes.idUnidadeUniversitaria }}
        <span *ngIf="detalhes.campus">- {{ detalhes.campus }}</span>
      </p>
      <p *ngIf="detalhes.idLotacaoOficial">
        <b>Lotação:</b> {{ detalhes.idLotacaoOficial }} - {{ detalhes.nomeLotacaoOficial }}
      </p>
      <p><b>Perfis:</b> {{ detalhes.authorities.join(',  ') }}</p>
    </div>
    <div *ngSwitchCase="'CARGA_HORARIA'">
      <table>
        <thead>
          <th>#</th>
          <th>Item plano</th>
          <th>Prevista</th>
          <th>Efetiva</th>
        </thead>
        <tbody>
          <tr *ngFor="let row of detalhes">
            <td>{{ row.idItemPlano }}</td>
            <td>{{ row.descricaoItemPlano }}</td>
            <td>{{ row.cargaHorariaPrevista }}</td>
            <td>{{ row.cargaHorariaEfetiva }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngSwitchCase="'INSERT'">
      <div *ngFor="let campo of detalhes | keyvalue">
        <span
          ><b>{{ campo.key }}:</b></span
        >
        {{ campo.value }}
      </div>
    </div>
    <div *ngSwitchCase="'UPDATE'">
      <div *ngFor="let campo of detalhes | keyvalue">
        <span
          ><b>{{ campo.key }}:</b></span
        >
        {{ campo.value }}
      </div>
    </div>
    <div *ngSwitchCase="'UNDO'">
      <div *ngFor="let campo of detalhes | keyvalue">
        <span
          ><b>{{ campo.key }}:</b></span
        >
        {{ campo.value }}
      </div>
    </div>
    <div *ngSwitchCase="'NOTIFY'">
      <div *ngFor="let campo of detalhes | keyvalue">
        <span
          ><b>{{ campo.key }}:</b></span
        >
        {{ campo.value }}
      </div>
    </div>
    <div *ngSwitchDefault></div>
  </div>
</mat-dialog-content>
<br />
<mat-card-actions>
  <div fxLayoutAlign="end">
    <button mat-button mat-dialog-close>Fechar</button>
  </div>
</mat-card-actions>
